module.exports = __webpack_public_path__ + "img/loja_atualizada_icon.92bf6bb4.svg";